<button class="button {{ buttonClass }}"
        type="button"
        [class.-active]="isActive"
        [disabled]="disabled || (!isToggle() && isActive)"
        [attr.id]="buttonId"
        [attr.title]="label"
        [attr.accesskey]="accessKey"
        (click)="performAction($event)">
  <op-icon icon-classes="{{ iconClass }} button--icon" />
</button>
